import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ButtonCloseDialogComponent } from '../button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from '../button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from '../button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonSaveComponent } from '../button-save/button-save.component';
import { MatSelectModule } from '@angular/material/select';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { UsuarioSummaryDto } from '@models/usuario/usuarioSummaryDto.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { EmpresaUsuarioService } from '@services/empresaUsuario/empresaUsuario.service';
import { EmpresaUsuarioDto } from '@models/empresaUsuario/empresaUsuarioDto.model';
import { AvatarInicialesComponent } from '../avatar-iniciales/avatar-iniciales.component';
import { EmpresaUsuarioSummaryDto } from '@models/empresaUsuario/empresaUsuarioSummaryDto.model';

@Component({
  selector: 'app-select-usuarios-empresa',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, MatSelectModule, A11yModule, CommonModule, MatExpansionModule, NgxSpinnerModule, AvatarInicialesComponent],
  templateUrl: './select-usuarios-empresa.component.html',
  styleUrl: './select-usuarios-empresa.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectUsuariosEmpresaComponent {

  @Input() idUsuarioEmpresaIngresado: number | null = null;
  @Input() label: number | null = null;

  usuarioEmpresaIngresado: EmpresaUsuarioSummaryDto | null = null;
  empresaUsuarios: EmpresaUsuarioSummaryDto[] = [];
  @Output() usuarioSeleccionado = new EventEmitter<EmpresaUsuarioSummaryDto | null>();

  formBuilder = new FormBuilder
  formFilter!: FormGroup;
  constructor(
    private empresaUsuarioService: EmpresaUsuarioService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
  ) {
    this.formFilter = this.formBuilder.group({
      EmpresaUsuario: [null],
    });

  }
  ngOnInit(): void {
    this.getAllUsuariosEmpresa();
  }

  onUsuarioChange(user: any) {
    const seleccionado = this.empresaUsuarios.find(u => u.id === user.id) || null;
    this.usuarioSeleccionado.emit(seleccionado);
  }

  getAllUsuariosEmpresa() {
    this.spinner.show('spUsuarioEmpresa')
    this.empresaUsuarioService.getAllUsuariosSummaryByEmpresa()
      .subscribe(
        data => {
          this.spinner.hide('spUsuarioEmpresa')
          this.empresaUsuarios = data

          if (this.idUsuarioEmpresaIngresado) {
            const seleccionado = this.empresaUsuarios.find(eu => eu.usuario?.id === this.idUsuarioEmpresaIngresado);
            if (seleccionado) {
              this.usuarioEmpresaIngresado = seleccionado;
              this.formFilter.get('EmpresaUsuario')?.setValue(seleccionado);
            }
          }

        },
        error => {
          this.spinner.hide('spUsuarioEmpresa')
          this.snackBar.showError(error, "Error");
        })
  }



  trackByUsuario(index: number, usuario: UsuarioSummaryDto): number {
    return usuario.id;
  }


}
